import {useMutation} from "@tanstack/react-query";

import {deleteLeadMutationOptions} from "./delete-lead.mutation-options";

export function useDeleteLead() {
  return useMutation(deleteLeadMutationOptions());
}
